import React from 'react';
import Image from 'next/image';

import { IWhyUsProps } from './interfaces';

import { imageSerializer } from '../../../utils/imageSerializer';

import {
  ImageWrapper,
  Reason,
  ReasonDescription,
  Reasons,
  ReasonTitle,
  TextContainer,
  Title,
  Wrapper,
} from './whyUs.styles';

export const WhyUs = ({
  title,
  reasons,
  titleAs,
}: IWhyUsProps): JSX.Element => {
  return (
    <Wrapper>
      <Title as={titleAs}>{title}</Title>
      <Reasons>
        {reasons.map((reason, index) => (
          <Reason key={index}>
            <ImageWrapper>
              <Image {...imageSerializer(reason.image)} />
            </ImageWrapper>
            <TextContainer>
              <ReasonTitle>{reason.title}</ReasonTitle>
              <ReasonDescription>{reason.description}</ReasonDescription>
            </TextContainer>
          </Reason>
        ))}
      </Reasons>
    </Wrapper>
  );
};
